export function filterObject(obj: any): Partial<any> {
  const filtered: Partial<any> = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
      filtered[key] = obj[key];
    }
  }
  return filtered;
}
